import { useState, useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import OrderReview from 'public/components/DefaultLayout/OrderReview';
import { FarmProduct } from 'public/context/CartContext';
import { Spinner } from 'ui';
import useQueryApiClient from 'utils/useQueryApiClient';
import { StyledOrderPage } from './style';
import { useAuth } from 'hooks/useAuth';
import { useNavigate } from 'react-router-dom';

export const OrderPage = () => {
  const [farmProducts, setFarmProducts] = useState<FarmProduct[]>([]);
  const [priceTotal, setPriceTotal] = useState<number>(0);
  let [searchParams] = useSearchParams();
  const orderId = searchParams.get('order_id');

  const navigate = useNavigate();
  const { user } = useAuth();

  useEffect(() => {
    if (user !== null && !user?.authenticated) {
      navigate('/login', { replace: true });
    }
  }, [navigate, user]);

  const { isLoading: orderLoading } = useQueryApiClient({
    request: {
      url: `/api/v2/farm/order/${orderId}`,
      method: 'GET',
    },
    onSuccess: (response) => {
      setFarmProducts(response.farmProducts);
      setPriceTotal(response.priceTotal);
    },
  });

  return (
    <StyledOrderPage>
      <div className={'container'}>
        <Spinner spinning={orderLoading}>
          <OrderReview
            priceTotal={priceTotal}
            farmProducts={farmProducts}
            isView={true}
          />
        </Spinner>
      </div>
    </StyledOrderPage>
  );
};
